module.exports = __webpack_public_path__ + "img/arrow-block-up.900ff1ee.svg";